import React from 'react';
import styled from 'styled-components';

function Icon(props) {
  const { icon } = props;
  const style = props.style ? props.style : {};

  const { width, height, color, padding, margin, className } = style;

  const StyledIcon = styled(icon)`
    width: ${(props) => (props.width ? props.width + 'px' : '16px')};
    height: ${(props) => (props.height ? props.height + 'px' : '16px')};
    color: ${(props) => (props.color ? props.color : '#ffffff')};
    padding: ${(props) => (props.padding ? props.padding : '0px')};
    margin: ${(props) => (props.margin ? props.margin : '4px')};
  `;

  return (
    <StyledIcon
      className={className}
      width={width}
      height={height}
      color={color}
      margin={margin}
      padding={padding}
      {...props}
    ></StyledIcon>
  );
}

export default Icon;
export { EditIcon } from './EditIcon';
